import React, { Fragment } from 'react';
import parkinghub from '../../../../../images/parkinghub2.png';

import '../../driverFaq.css';
import WalkingAccess from './WalkingAccess';
import PersonalVehicleAccess from './PersonalVehicleAccess';

const ParkingHub = () => (
  <Fragment>
    <p style={{ color: 'grey' }}>Toronto Downtown</p>
    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
      <li>
        Location: Kimpton Hotel Saint George - Indigo Parking Facility
      </li>
      <li>Address: 280 Bloor Street West, (P3) Toronto ON M5S 1V8</li>
      <li>
        Intersection: Bloor St./St. George with access on both Bloor or St.
        George (parking only)
      </li>
      <li>
        Closest subway stations: St. George Station or Spadina Station
      </li>
    </ul>
    <br />
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
      <img src={parkinghub} className="hub-location-image" />
    </div>
    <br />
    <p>
      The parking location is a 20-second walk from St. George subway
      station or a 5-minute walk from Spadina subway station.
    </p>
    <br />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot by walking?
    </p>
    <WalkingAccess />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot with my personal vehicle? (free
      parking)
    </p>
    <PersonalVehicleAccess />
  </Fragment>
);

export default ParkingHub;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Bloor/ParkingHub.js